import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import React, { Component } from "react";
import Login from "./components/login";
import ForgotPassword from "./components/forgotPassword";
import ResetPassword from "./components/resetPassword";
import Wip from "./components/wip";
import Home from "./components/Home";
import Customers from "./components/customers/customers";
import requireAuth from "./utils/auth";
import CreateCustomer from "./components/customers/createCustomer";
import CreateAsset from "./components/assets/createAsset";
import CustomerDetail from "./components/customers/customerDetail";
import users from "./components/users/users";
import CreateUser from "./components/users/CreateUser";
import EditUser from "./components/users/EditUser";
import UserDetails from "./components/users/UserDetails";
import UserDelete from "./components/users/userDelete";
import Assets from "./components/assets/assets";
import EditAsset from "./components/assets/editAsset";
import DeleteAsset from "./components/assets/deleteAsset";
import AssetDetail from "./components/assets/assetDetails";
import Groups from "./components/groups/Groups";
import CreateGroup from "./components/groups/CreateGroup";
import EditGroup from "./components/groups/editGroup";
import GroupDetails from "./components/groups/groupDetails";
import GroupDelete from "./components/groups/groupDelete";
import Depots from "./components/depots/depot";
import Zones from "./components/zones/zone";
import CreateDepot from "./components/depots/createDepot";
import CreateZone from "./components/zones/createZone";
import Devices from "./components/devices.js/devices";
import CreateDevice from "./components/devices.js/createDevice";
import EditDevice from "./components/devices.js/editDevice";
import DeviceDetails from "./components/devices.js/deviceDetails";
import DeleteDevice from "./components/devices.js/deleteDevice";
import Drivers from "./components/drivers/drivers";
import DepotDetails from "./components/depots/depotDetails";
import ZoneDetails from "./components/zones/zoneDetails";
import DeleteDepot from "./components/depots/deleteDepot";
import DeleteZone from "./components/zones/deleteZone";
import RealTime from "./components/realTime/realTime";
import Events from "./components/events/events";
import CreateEvent from "./components/events/createEvent";
import EditEvent from "./components/events/editEvent";
import EventDetails from "./components/events/eventDetails";
import DeleteEvent from "./components/events/deleteEvent";
import Notification from "./components/notification/notification";
import createNotification from "./components/notification/createNotification";
import EditNotification from "./components/notification/editNotification";
import NotificationDetails from "./components/notification/notificationDetails";
import DeleteNotification from "./components/notification/deleteNotificaion";
import Visioncam from "./components/visioncam/Visioncam";
import Apps from "./components/apps/Apps";
import TomDelivery from "./components/tomdelivery/TomDelivery";

import alert from "./components/alertCentre/alerts";
import LiveAlert from "./components/assets/liveAlert";
import MVTRIPLOG from "./components/reports/mvtl/mvtriplog";
import Temperature from "./components/reports/temperature/temperature";
import AssetRunningSummary from "./components/reports/assetRunningSummary/assetRunningSuccess";
import GroupRunningSummary from "./components/reports/groupRunningSummary/groupRunningSummary";
import visit from "./components/reports/visit/visit";
import LocationData from "./components/reports/location/locationData";
import PointOfInterest from "./components/reports/pointOfInterest/pointOfInterest";
import GeofenceEntryExit from "./components/reports/geofence/geofenceEntryExit";
import RunSheets from "./components/reports/runSheets/runSheets";
import RunSheetMissingGps from "./components/reports/runSheets/runSheetMissingGps";
import RunSheetDispatchSummary from "./components/reports/runSheets/runSheetDispatchSummary";
import ErpAssetMappings from "./components/erp/erpAssetMappings";
import multiasset from "./components/reports/multiasset/multiasset";
import Track from "./components/reports/track/track";
import Timeline from "./components/reports/timeline/timeline";
import Replay from "./components/reports/replay/replay";
import ChecklistRunsReport from "./components/reports/checklists/checklistRunsReport";
import manageAccount from "./components/profile/manageAccount";
import Error from "./error";
import { ProtectedRoute } from "./protectedRoute";
import unauthorise from "./unauthorise";
import editCustomer from "./components/customers/editCustomer";
import editDepot from "./components/depots/editDepot";
import editZone from "./components/zones/editZone";
import Header from "./Layout/header";
import PageVisitTracker from "./utils/pageVisitTracker";
import bellNotification from "./components/alertCentre/bellNotification";
import ibutton from "./components/ibutton/ibutton";
import editIbutton from "./components/ibutton/editIbutton";
import detailsIbutton from "./components/ibutton/detailsIbutton";
import deleteIbutton from "./components/ibutton/deleteIbutton";
import UploadCsv from "./components/zones/uploadCsv";
import iButtonRptData from "./components/reports/iButtonRpt/iButtonRptData";
import AssetReportDetail from "./components/reports/assetReport/assetReportDetail";
import PageVisits, { PageVisitsHeatMap } from "./components/pageVisits/pageVisits";
import NewsArchive from "./components/news/newsArchive";
import NewsAdmin from "./components/news/newsAdmin";
import NewsLoginModal from "./components/news/newsLoginModal";
import SupportButton from "./components/support/supportButton";
import MaintenanceDue from "./components/maintenance/maintenanceDue";
import MaintenanceEdit from "./components/maintenance/maintenanceEdit";
import MaintenanceSubscribers from "./components/maintenance/maintenanceSubscribers";
import NonTrackedAssets from "./components/assets/nonTrackedAssets";
import RawMessageDiagnostics from "./components/admin/rawMessageDiagnostics";
import ChecklistNotifications from "./components/checklists/checklistNotifications";
import HelpCentre from "./components/helpCentre/HelpCentre";
import HelpCentreAdmin from "./components/helpCentre/HelpCentreAdmin";
class Router extends Component {
  render() {
    return (
      <div>
        <BrowserRouter>
          <Header />
          <NewsLoginModal />
          <SupportButton />
          <PageVisitTracker />
          <Switch>
            <Route path="/login" component={Login} exact />
            <Route path="/forgot-password" component={ForgotPassword} exact />
            <Route path="/reset-password" component={ResetPassword} exact />
            <Route
              path="/"
              render={(props) => {
                const HomeWithMaintenanceDue = requireAuth(Home);
                return <HomeWithMaintenanceDue {...props} showMaintenanceDueTile />;
              }}
              exact
            />
            <Route
              path="/home"
              render={(props) => {
                const HomeWithMaintenanceDue = requireAuth(Home);
                return <HomeWithMaintenanceDue {...props} showMaintenanceDueTile />;
              }}
              exact
            />
            <Redirect from="/home2" to="/home" exact />
            <ProtectedRoute path="/customers" component={requireAuth(Customers)} allowedRoles={["SystemAdmin"]} exact />
            <ProtectedRoute path="/ibutton" component={requireAuth(ibutton)} allowedRoles={["SystemAdmin"]} exact />
            <ProtectedRoute
              path="/editIbutton/:id"
              component={requireAuth(editIbutton)}
            />
            <ProtectedRoute
              path="/ibuttonDetails/:id"
              component={requireAuth(detailsIbutton)}
            />
            <ProtectedRoute
              path="/deleteIbutton/:id"
              component={requireAuth(deleteIbutton)}
            />
            <Route path="/assets" component={requireAuth(Assets)} exact />
            <ProtectedRoute
              path="/depots"
              component={requireAuth(Depots)}
              allowedRoles={["SystemAdmin", "VtDemo", "VTDemo", "CommunityManager", "Community Manager"]}
              exact
            />
            <ProtectedRoute
              path="/viewDepot/:id"
              component={requireAuth(editDepot)}
              allowedRoles={["VtDemo", "VTDemo", "CommunityManager", "Community Manager"]}
              readOnly
            />
            <Route path="/zones" component={requireAuth(Zones)} exact />
            <Route path="/dashboard" component={requireAuth(Wip)} exact />
            <Route path="/realTime" component={requireAuth(RealTime)} exact />
            <ProtectedRoute
              path="/createCustomer"
              component={requireAuth(CreateCustomer)}
              exact
            />
            <ProtectedRoute
              path="/createDepot"
              component={requireAuth(CreateDepot)}
              exact
            />
      
            <ProtectedRoute
              path="/editCustomer/:id"
              component={requireAuth(editCustomer)}
            />
            <ProtectedRoute
              path="/createDepot"
              component={requireAuth(CreateDepot)}
              exact
            />
            <ProtectedRoute
              path="/editDepot/:id"
              component={requireAuth(editDepot)}
              allowedRoles={["SystemAdmin"]}
            />

            <Route
              path="/createZone"
              component={requireAuth(CreateZone)}
              exact
            />
            <Route
              path="/uploadCsv"
              component={requireAuth(UploadCsv)}
              exact
            />
            <Route
              path="/editZone/:id"
              component={requireAuth(editZone)}
            />

            <Route
              path="/zoneDetails/:id"
              component={requireAuth(ZoneDetails)}
            />

            <Route
              path="/deleteZone/:id"
              component={requireAuth(DeleteZone)}
            />

             <Route path="/editAsset/:id" component={EditAsset} />

             <Route
              path="/assetDetail/:id"
              component={requireAuth(AssetDetail)}
            />

            <Route
              path="/deleteAsset/:id"
              component={requireAuth(DeleteAsset)}
            />
            <Route
              path="/liveAlert/:id"
              component={requireAuth(LiveAlert)}
            />
            <Route
              path="/createAsset"
              component={requireAuth(CreateAsset)}
              exact
            />
            <ProtectedRoute
              path="/depotDetails/:id"
              component={requireAuth(DepotDetails)}
            />
         
            <ProtectedRoute
              path="/deleteDepot/:id"
              component={requireAuth(DeleteDepot)}
            />
       
            <ProtectedRoute
              path="/customerDetail/:id"
              component={requireAuth(CustomerDetail)}
            /> 
            <ProtectedRoute
              path="/users"
              component={requireAuth(users)}
              allowedRoles={["SystemAdmin", "VtDemo", "VTDemo", "CommunityManager", "Community Manager"]}
              exact
            />
            <ProtectedRoute
              path="/create-new-user"
              component={requireAuth(CreateUser)}
              exact
            />
            <ProtectedRoute
              path="/editUser/:id"
              component={requireAuth(EditUser)}
            />
            <ProtectedRoute
              path="/userDetails/:id"
              component={requireAuth(UserDetails)}
            />
            <ProtectedRoute
              path="/deleteUser/:id"
              component={requireAuth(UserDelete)}
            />
           

            <ProtectedRoute path="/groups" component={requireAuth(Groups)} />
            <ProtectedRoute
              path="/create-new-group"
              component={requireAuth(CreateGroup)}
            />
            <ProtectedRoute
              path="/editGroup/:id"
              component={requireAuth(EditGroup)}
            />
            <ProtectedRoute
              path="/deleteGroup/:id"
              component={requireAuth(GroupDelete)}
            />
            <ProtectedRoute
              path="/groupDetails/:id"
              component={requireAuth(GroupDetails)}
            />
            <ProtectedRoute path="/devices" component={requireAuth(Devices)} />
            <ProtectedRoute
              path="/drivers"
              component={requireAuth(Drivers)}
              allowedRoles={["SystemAdmin", "VtDemo", "VTDemo", "CommunityManager", "Community Manager"]}
              exact
            />
            <ProtectedRoute
              path="/create-new-devices"
              component={requireAuth(CreateDevice)}
            />
            <ProtectedRoute
              path="/editDevice/:id"
              component={requireAuth(EditDevice)}
            />
            <ProtectedRoute
              path="/deviceDetails/:id"
              component={requireAuth(DeviceDetails)}
            />
            <ProtectedRoute
              path="/deleteDevice/:id"
              component={requireAuth(DeleteDevice)}
            />
            <ProtectedRoute path="/events" component={requireAuth(Events)} />
            <ProtectedRoute
              path="/create-new-event"
              component={requireAuth(CreateEvent)}
            />
            <ProtectedRoute
              path="/editEvent/:id"
              component={requireAuth(EditEvent)}
            />
            <ProtectedRoute
              path="/eventDetails/:id"
              component={requireAuth(EventDetails)}
            />
            <ProtectedRoute
              path="/eventDelete/:id"
              component={requireAuth(DeleteEvent)}
            />
            <Route
              path="/notifications"
              component={requireAuth(Notification)}
            />
            <Route
              path="/create-new-notification"
              component={requireAuth(createNotification)}
            />
            <Route
              path="/editNotification/:id"
              render={(props) => (
                <EditNotification key={props.match.params.id} {...props} />
              )}
            />
            <Route
              path="/notificationDetails/:id"
              render={(props) => (
                <NotificationDetails key={props.match.params.id} {...props} />
              )}
            />
            <Route
              path="/notificationDelete/:id"
              render={(props) => (
                <DeleteNotification key={props.match.params.id} {...props} />
              )}
            />
            <Route path="/AlertCentre" component={requireAuth(alert)} />
            <Route
              path="/AlertNotification"
              component={requireAuth(bellNotification)}
            />
            <Route path="/Rpt-MVTL" component={requireAuth(MVTRIPLOG)} />
            <Route path="/Rpt-Visit" component={requireAuth(visit)} />
            <Route path="/Temperature" component={requireAuth(Temperature)} />
            <Route path="/Track" component={requireAuth(Track)} />
            <Route path="/Replay" component={requireAuth(Replay)} />
            <Route path="/Timeline" component={requireAuth(Timeline)} />
            <Route path="/Driver-Logs" component={requireAuth(ChecklistRunsReport)} />
            <Route path="/Driver-Logs-Checklist" component={requireAuth(ChecklistRunsReport)} />
            <Route path="/Rpt-ChecklistRuns" component={requireAuth(ChecklistRunsReport)} />
            <Route
              path="/Rpt-summary"
              component={requireAuth(AssetRunningSummary)}
            />
            <Route
              path="/Rpt-Group-Summary"
              component={requireAuth(GroupRunningSummary)}
            />
            <Route
              path="/Rpt-LocationData"
              component={requireAuth(LocationData)}
            />
            <Route
              path="/Rpt-PointOfInterest"
              component={requireAuth(PointOfInterest)}
            />
            <Route
              path="/Rpt-Geofence"
              component={requireAuth(GeofenceEntryExit)}
            />
            <Route
              path="/Rpt-RunSheets"
              component={requireAuth(RunSheets)}
            />
            <Route
              path="/RunSheet-Missing-GPS"
              component={requireAuth(RunSheetMissingGps)}
            />
            <Route
              path="/RunSheet-Dispatch-Summary"
              component={requireAuth(RunSheetDispatchSummary)}
            />
            <Route path="/MultiVisit" component={requireAuth(multiasset)} />
            <Route
              path="/manageAccount"
              component={requireAuth(manageAccount)}
            />
            <Route
              path="/Rpt-IButton"
              component={requireAuth(iButtonRptData)}
            />
            <ProtectedRoute
              path="/erp-asset-mappings"
              component={requireAuth(ErpAssetMappings)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/asset-log-report"
              component={requireAuth(AssetReportDetail)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/maintenance-subscribers"
              component={requireAuth(MaintenanceSubscribers)}
              allowedRoles={["SystemAdmin"]}
              exact
            />
            <ProtectedRoute
              path="/page-visits/user/:userId"
              component={requireAuth(PageVisits)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/page-visits-heat-map"
              component={requireAuth(PageVisitsHeatMap)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/page-visits"
              component={requireAuth(PageVisits)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/raw-message-diagnostics"
              component={requireAuth(RawMessageDiagnostics)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/news-admin/create"
              component={requireAuth(NewsAdmin)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/news-admin/edit/:id"
              component={requireAuth(NewsAdmin)}
              allowedRoles={["SystemAdmin"]}
            />
            <ProtectedRoute
              path="/news-admin"
              component={requireAuth(NewsAdmin)}
              allowedRoles={["SystemAdmin"]}
              exact
            />
            <Route path="/news" component={requireAuth(NewsArchive)} exact />
            <Route path="/help-centre" component={requireAuth(HelpCentre)} exact />
            <ProtectedRoute path="/help-centre/admin" component={requireAuth(HelpCentreAdmin)} allowedRoles={["SystemAdmin"]} exact />
            <Route path="/maintenance-due/:assetId" component={requireAuth(MaintenanceEdit)} exact />
            <Route path="/maintenance-due" component={requireAuth(MaintenanceDue)} exact />
            <Route path="/non-tracked-assets" component={requireAuth(NonTrackedAssets)} exact />
            <Route path="/checklist-notifications" component={requireAuth(ChecklistNotifications)} exact />
            <Route path="/visioncam" component={requireAuth(Visioncam)} />
            <Route path="/apps" component={requireAuth(Apps)} exact />
            <Route path="/tom-delivery" component={requireAuth(TomDelivery)} />
            <Route path="/unauthorise" component={unauthorise} />
            <Route path="/404" component={Error} />
            <Redirect to="/404" />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}
export default Router;
